import orderPrintDocumentsService from "./services/orderPrintDocumentsService.js";
import OrderPrintDocumentsCtrl from "./controllers/orderPrintDocumentsController.js";
import { orderPrintDocumentsDirective } from "./directives/orderPrintDocumentsDirective.js";
import './styles/orderPrintDocuments.scss';
const moduleName = 'orderPrintDocuments';
angular.module(moduleName, []).service('orderPrintDocumentsService', orderPrintDocumentsService).controller('OrderPrintDocumentsCtrl', OrderPrintDocumentsCtrl).directive('orderPrintDocuments', orderPrintDocumentsDirective);
export default moduleName;